"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepCompareEffect = void 0;
const react_1 = require("react");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const isPrimitive = (val) => val !== Object(val);
function useDeepCompareEffect(effect, deps) {
    if (process.env.NODE_ENV !== 'production') {
        if (!deps || !deps.length) {
            console.warn('`useDeepCompareEffect` should not be used with no dependencies. Use React.useEffect instead.');
        }
        if (deps.every(isPrimitive)) {
            console.warn('`useDeepCompareEffect` should not be used with dependencies that are all primitive values. Use React.useEffect instead.');
        }
    }
    const ref = react_1.useRef(undefined);
    if (!react_fast_compare_1.default(deps, ref.current)) {
        ref.current = deps;
    }
    react_1.useEffect(effect, ref.current);
}
exports.useDeepCompareEffect = useDeepCompareEffect;
//# sourceMappingURL=useDeepCompareEffect.js.map